// Alt SEO des images produit (version ES de l'utilitaire FR) : [tipo de producto] + [calificativo] + [resto del título].
// Calificativo = color (variaciones) o « personalizado/a ». Si el título ya contiene « personaliz… », no se repite.
// Ej. « BOLSO DE TELA "LUNA" 280 (G/M²) » → « Bolso personalizado de tela "luna" 280 (g/m²) ».

// Del más específico al más genérico (gana el primer prefijo que coincide).
const PRODUCT_TYPES = [
  ["bolsa con cordón", "f"],
  ["bolsa con cordon", "f"],
  ["bolsa", "f"],
  ["bolso", "m"],
  ["saco", "m"],
  ["neceser", "m"],
  ["mochila", "f"],
  ["bandolera", "f"],
  ["camiseta", "f"],
  ["sudadera", "f"],
  ["polo", "m"],
  ["gorra", "f"],
  ["gorro", "m"],
  ["delantal", "m"],
  ["chaleco", "m"],
];

const agree = (word, gender) => (gender === "f" && word === "personalizado" ? "personalizada" : word);

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const productAlt = (title, color) => {
  const t = (title || "").normalize("NFC").toLowerCase().replace(/\s+/g, " ").trim();
  if (!t) return "";
  const type = PRODUCT_TYPES.find(([word]) => t === word || t.startsWith(`${word} `));
  if (!type) return capitalize(t);
  const [word, gender] = type;
  const rest = t.slice(word.length).trim();
  if (!color && /personaliz/.test(rest)) return capitalize(t);
  const qualifier = color ? color.toLowerCase().trim() : agree("personalizado", gender);
  return capitalize([word, qualifier, rest].filter(Boolean).join(" "));
};
